module.exports = __webpack_public_path__ + "img/scissor.2c2dc66e.svg";